<template>
  <div class="list-container">
    <div v-show="!dialogFormVisible && !quotationVisible && !orderVisible && !marketFeeVisible && !materDeliveryVisible">
      <div class="filter-container">
        <template v-if="!isFilterCollapse">
          <template v-for="(field) in FilterField" :key="field.fieldKey">
            <div
              class="filter-box"
              v-if="!field.visible || field.visible({
                pageType,
                type,
                showStateFilter
              }) "
            >
              <span class="label">{{field.fieldName}}</span>
              <el-input
                v-if="field.componentType === 'el-input'"
                v-model="listQuery[field.fieldKey]"
                :size="t('table.btnSize')"
                class="filter-item"
                clearable
                @keyup.enter="handleFilter"
              />
              <el-select :filterable="true" v-else-if="field.componentType === 'el-select'" v-model="listQuery[field.fieldKey]" class="filter-item" placeholder="" clearable :size="t('table.btnSize')" @focus="handleFilterFocus(field)" @change="handleFilter">
                <template v-if="handleFilterOptions(field).length">
                  <el-option
                    v-for="item in handleFilterOptions(field)"
                    :key="item.id"
                    :label="item.mark"
                    :value="item.id"
                  />
                </template>
                <el-option v-else :value="-1" disabled>暂无数据</el-option>
              </el-select>
            </div>
          </template>

          <!-- <div class="filter-box">
            <span class="label">订单号</span>
            <el-input
              v-model="listQuery.orderNo"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div> -->
          <div class="filter-box" v-if="isReceivedPage() || isReceivedDonePage()" >
            <span class="label">所属公司</span>
            <el-select :filterable="true" v-model="listQuery.titleId" class="filter-item" placeholder="" clearable :size="t('table.btnSize')" @focus="handleFilterTitleFocus()" @change="handleFilter">
              <template v-if="getTitleCompanyOptions().length">
                <el-option
                  v-for="item in getTitleCompanyOptions()"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </template>
              <el-option v-else :value="-1" disabled>暂无数据</el-option>
            </el-select>
          </div>
          <div class="filter-box">
            <span class="label">登记日期</span>
            <el-date-picker
              v-model="listQuery.startTime"
              type="date"
              placeholder=" "
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @change="handleFilter"
              :size="t('table.btnSize')"
            >
            </el-date-picker>
          </div>
          <div class="filter-box">
            <span class="label">结束日期</span>
            <el-date-picker
              v-model="listQuery.endTime"
              type="date"
              placeholder=" "
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @change="handleFilter"
              :size="t('table.btnSize')"
            >
            </el-date-picker>
          </div>
          <div class="filter-box" v-if="isReceivedDonePage()">
            <span class="label">收款时间</span>
            <el-date-picker
              v-model="listQuery.receiveStartDate"
              type="date"
              placeholder=" "
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @change="handleFilter"
              :size="t('table.btnSize')"
            >
            </el-date-picker>
          </div>
          <div class="filter-box" v-if="isReceivedDonePage()">
            <span class="label">至</span>
            <el-date-picker
              v-model="listQuery.receiveEndDate"
              type="date"
              placeholder=" "
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @change="handleFilter"
              :size="t('table.btnSize')"
            >
            </el-date-picker>
          </div>
          <div class="filter-box" v-if="isBusinessPage()" >
            <el-radio-group v-model="listQuery.receivedStatus" @change="handleFilter">
              <el-radio label="0,2" >未收款</el-radio>
              <el-radio label="3" >已收款</el-radio>
              <el-radio label="4" >无需收款</el-radio>
              <el-radio label="" >全部</el-radio>
            </el-radio-group>
          </div>
        </template>
        <div class="filter-box">
          <el-button
            v-waves
            class="filter-item "
            type="primary"
            :size="t('table.btnSize')"
            @click="handleFilter"
          >
            {{ t('table.search') }}
          </el-button>
          <el-button
            v-permission="{ pkey: `${permissionName}_ADD` }"
            class="filter-item"
            type="primary"
            :size="t('table.btnSize')"
            @click="handleCommand('add')"
          >
            {{ t('table.add') }}
          </el-button>
          <el-button
            v-permission="{ pkey: `${permissionName}_QUATION` }"
            class="filter-item"
            type="primary"
            :size="t('table.btnSize')"
            @click="handleCommand('quotation')"
          >
            报价
          </el-button>
          <el-button
            v-permission="{ pkey: `${permissionName}_ORDER` }"
            class="filter-item"
            type="primary"
            :size="t('table.btnSize')"
            @click="handleCommand('order')"
          >
            创建订单
          </el-button>
          <el-button
            v-waves
            class="filter-item"
            :size="t('table.btnSize')"
            @click="handleReset"
          >
            {{ t('table.reset') }}
          </el-button>
          <el-button
            v-waves
            class="filter-item"
            :size="t('table.btnSize')"
            @click="isFilterCollapse = !isFilterCollapse"
          >
            {{ isFilterCollapse ? '展开' : '收起' }}
          </el-button>
          <span class="svg-icon cursor mr-10 ml-10" @click="handleCommand('refresh')">
            <i class="icon-tubiao-27 iconfont"/>
          </span>
          <span class="svg-icon cursor" @click="handleCommand('column')">
            <i class="icon-tubiao-28 iconfont"/>
          </span>
          <span class="ml-10 filter-mark" v-if="mainPage">
            <span class="status-item"><span class="status-square" style="background-color: red;"></span><span class="status-text">待报价</span></span>
            <span class="status-item"><span class="status-square" style="background-color: blue;"></span><span class="status-text">待订单</span></span>
            <span class="status-item"><span class="status-square" style="background-color: gray;"></span><span class="status-text">已取消</span></span>
          </span>
        </div>
      </div>
      <div class="split-table-layout">
        <!-- 主表区域 -->
        <div
          class="split-pane-top vue-grid-item"
          :style="{ height: isSubMenuCollapse ? '100%' : `${topHeight}px` }"
        >
          <TableList
              :ref="el => { if (el) tableListRef[0] = el }"
              v-loading="listLoading"
              :dataList="list"
              :columnAllData="columnAllData"
              :tableName="TableName"
              :permissionName="permissionName"
              :showSelection="true"
              :isShowPagination="false"
              :handleDefaultWidth="140"
              :highlightCurrentRow="true"
              :layoutHeight="true"
              :newHpx="newHpx"
              :canRefresh="false"
              :canChangeColumn="false"
              :canCommand="canCommand"
              :tableRowClassName="tableRowClassName"
              :showSummary="showSummary"
              style="height:100%;overflow:hidden;"
              @row-click="handleRowClick"
              @command-change="handleCommand"
            >
              <template v-slot:no="scope" v-if="mainPage">
                <span
                  :class="scope.row.changeStatus === '发起修改' ? 'redStatusStyle' : scope.row.changeStatus === '申请取消' ? 'yellowStatusStyle' : ''"
                  class="statusStyle">
                  <template v-if="['发起修改', '申请取消'].includes(scope.row.changeStatus)">
                    <i class="iconfont icon-tubiao-40"></i>
                    <span class="status">{{ scope.row.changeStatus }} </span>
                  </template>
                  <span>{{ scope.row.no }}</span>
                </span>
              </template>
              <template v-slot:operation-action="scope">
                <CommandRender
                  v-if="showDefaultCommand && scope.row.status !== '已取消' && scope.row.changeStatus !== '申请取消'"
                  :scopeRow='scope.row'
                  :codeList="btnList"
                  :permissionName="permissionName"
                  @command-change="handleCommand"
                />
                <el-link
                  v-else
                  href="javascript:void(0);"
                  class="mr-10"
                  type="primary"
                  @click="handleCommand('preview', scope.row)"
                >
                  查看大图
                </el-link>
                <slot name="command" v-bind="{ scope }"/>
              </template>
            </TableList>
            <el-pagination
              class="mt-20"
              v-show="total > 0"
              :total="total"
              v-model:currentPage="listQuery.page"
              :page-size="listQuery.size"
              :page-sizes="pageSizes"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              layout="total, sizes, prev, pager, next"
            />
        </div>

        <!-- 水平交互分割线 -->
        <TableSplitter
          v-if="!isSubMenuCollapse && tabList.length"
          @drag-start="handleSplitterDragStart"
          @drag-move="handleSplitterDragMove"
          @drag-end="handleSplitterDragEnd"
        />

        <!-- 子表区域 -->
        <div
          v-show="!isSubMenuCollapse && tabList.length"
          class="split-pane-bottom"
          :style="{ height: `${bottomHeight}px` }"
        >
          <div class="clearfix tab-title btn-container mt-10">
                <ul class="tab-title_left fl">
                  <li
                    v-for="item in tabList"
                    :key="item.id"
                    :class="{ active: activeTab === item.id }"
                    @click="handleTabClick(item)">{{ item.name }}
                  </li>
                </ul>
              </div>
              <template v-if="tabList.length">
                <ContactList v-if="activeTab === 1" ref="ContactList" :id="activeId"/>
                <EngineerInfoList v-if="activeTab === 2" ref="EngineerInfoList" :id="activeId"/>
                <MarketFee
                  v-if="activeTab === 4"
                  ref="MarketFee"
                  :id="activeId"
                  :marketFeeCanCommand="marketFeeCanCommand"
                  :businessDetail="activeRow"
                />
                <OutsourceFee v-if="activeTab === 8" ref="OutsourceFee" :id="activeId" :businessDetail="activeRow"/>

                <ChargeFee v-if="activeTab === 5" ref="ChargeFee" :id="activeId" api="business"/>
                <LogisticTable
                  :sendFlag="0"
                  TableName="TABLE_DELIVERY_INFO"
                  permissionName="LOGISTIC_INFO"
                  v-if="activeTab === 6"
                  ref="LogisticTable"
                  :sourceId="activeId"
                  :sourceType="1"/>
                <TraceInfo v-if="activeTab === 3" ref="TraceInfo" :id="activeId" api="business"/>
                <InvoiceNumber v-if="activeTab === 7" ref="InvoiceNumber" :id="activeId" :api="`business/${activeId}/actions/invoice`"/>
                 <DeliverTable v-if="activeTab === 9" ref="DeliverTable" :id="activeId"/>
              </template>
        </div>
      </div>
    </div>
    <FormComponent
      v-if="dialogFormVisible"
      :id="activeId"
      :initFormData="initFormData"
      :fromFieldData="fromFieldData"
      :dialogFormVisible="dialogFormVisible"
      :api="'business'"
      :commandState="commandState"
      :isShowSubmitBtn="commandState !== 'view'"
      @update:visibel="() => dialogFormVisible = false"
      @submit="handleSubmit"
    />
    <!-- 市场费 -->
    <MarkerFeeCom
      v-if="marketFeeVisible"
      :id="0"
      :initFormData="initMarketFeeFieldData"
      :fromFieldData="marketFeeFieldData"
      :dialogFormVisible="marketFeeVisible"
      :api="`business/${activeId}/actions/marketFee`"
      :businessDetail="activeRow"
      method="PUT"
      @update:visibel="marketFeeVisible = false"
    />
    <QuotationFormCom
      v-if="quotationVisible"
      :dialogFormVisible="quotationVisible"
      :api="'quotation'"
      from="business"
      :selectionBusiness="selectionArray"
      :selectcCustomerCompanyId="selectcCustomerCompanyId"
      @update:visibel="() => quotationVisible = false"
      @submit="handleQuotatioSubmit(formData)"
    />
    <OrderFormCom
      v-if="orderVisible"
      :dialogFormVisible="orderVisible"
      :api="'order'"
      from="business"
      :selectionBusiness="selectionArray"
      :selectcCustomerCompanyId="selectcCustomerCompanyId.toString()"
      @update:visibel="() => orderVisible = false"
      @submit="handleQuotatioSubmit(formData)"
    />
    <el-dialog
      v-model="yejiVisible"
      title="设置业绩类型"
      width="40%"
      close-on-click-modal
      destroy-on-close
    >
      <div>
        <el-radio-group v-model="achieveType">
          <el-radio :label="item.id" v-for="item in yejiOption" :key="item.id">{{ item.mark }}</el-radio>
        </el-radio-group>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="yejiVisible = false;achieveType = ''" type="danger">取消</el-button>
          <el-button type="primary" @click="handleSetYeji">确定</el-button>
        </span>
      </template>
    </el-dialog>
    <!-- 取消业务 -->
    <el-dialog
      v-model="cancelBusinessVisible"
      title="提示"
      width="40%"
      close-on-click-modal
      destroy-on-close
    >
      <div v-for="(item, index) in cancelBusinessList" :key="index" style="display:flex;flex-flow:column">
        <span>第{{ index + 1 }}步:</span>
        <span style="padding: 6px 10px;">{{ item }}</span>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="danger" @click="cancelBusinessVisible = false;cancelBusinessList = []">关闭</el-button>
        </span>
      </template>
    </el-dialog>
    <el-dialog
      v-model="submitStepsVisible"
      title="提示"
      width="40%"
      close-on-click-modal
      destroy-on-close
    >
      <div v-for="(item, index) in stepsList" :key="index" style="display:flex;flex-flow:column">
        <span>第{{ index + 1 }}步:</span>
        <span style="padding: 6px 10px;">{{ item }}</span>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="danger" @click="submitStepsVisible = false;stepsList = []">关闭</el-button>
        </span>
      </template>
    </el-dialog>
    <el-dialog
      v-model="repairBackVisible"
      title="返修"
      width="30%"
      close-on-click-modal
      destroy-on-close
    >
      <el-form label-width="120px">
        <el-form-item label="工程师:" v-if="repairBackDialog.type !== '外包维修'">
          <el-select :filterable="true" v-model="repairBackDialog.engineerIds" class="filter-item" placeholder="输入关键字搜索" clearable multiple collapse-tags :size="t('table.btnSize')">
            <template v-if="engineerOption.length">
              <el-option
                v-for="item in engineerOption"
                :key="item.id"
                :label="item.mark"
                :value="item.id"
              />
            </template>
            <el-option v-else :value="-1" disabled>暂无数据</el-option>
          </el-select>
        </el-form-item>
        <template v-else>
          <el-form-item label="外包公司:">
            <el-select :filterable="true" v-model="repairBackDialog.outsourceCompanyId" class="filter-item" placeholder="输入关键字搜索" clearable :size="t('table.btnSize')" @change="handleOutsourceCompanyChange">
              <template v-if="outsourceCompanyOption.length">
                <el-option
                  v-for="item in outsourceCompanyOption"
                  :key="item.id"
                  :label="item.mark"
                  :value="item.id"
                />
              </template>
              <el-option v-else :value="-1" disabled>暂无数据</el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="外包公司联系人:">
            <el-select :filterable="true" v-model="repairBackDialog.outsourceCompanyContactId" class="filter-item" placeholder="输入关键字搜索" clearable :size="t('table.btnSize')">
              <template v-if="outsourceCompanyContactOption.length">
                <el-option
                  v-for="item in outsourceCompanyContactOption"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </template>
              <el-option v-else :value="-1" disabled>暂无数据</el-option>
            </el-select>
          </el-form-item>
        </template>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="repairBackVisible = false" type="danger">取消</el-button>
          <el-button type="primary" @click="repairBackVisible = false;handleRepairBackSubmit()">确定</el-button>
        </span>
      </template>
    </el-dialog>
    <el-dialog
      v-model="receivedRecordVisible"
      title="明细"
      width="40%"
      close-on-click-modal
      destroy-on-close
    >
      <ChargeFee :id="activeId" api="business"/>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="danger" @click="receivedRecordVisible = false">关闭</el-button>
        </span>
      </template>
    </el-dialog>
    <RegistCharge
      v-if="chargeVisible"
      :visible="chargeVisible"
      :selectRow="selectRow"
      :isRefund="true"
      title="业务退款"
      :multiWithCurrency="multiWithCurrency"
      @update:visibel="() => chargeVisible = false"
      @submit="getList()"
    />
    <ViewImageLlist
      v-if="viewImagesVisible"
      :images="activeRow.appearancePictures"
      :visible="viewImagesVisible"
      @update:visible="viewImagesVisible = false"
    />
    <FormDeliverComponent
      v-if="materDeliveryVisible"
      :id="activeId"
      type="BUSINESS"
      :handleResolveTempData="handleResolveTempData"
      @update:visibel="() => materDeliveryVisible = false"
      @submit="handleSubmit(formData)"
    />

    <el-button
      type="primary"
      circle
      @click="handleSubMenuCollapse"
      class="subMenuCollapseBtn"
      v-if="!dialogFormVisible && !quotationVisible && !orderVisible && !marketFeeVisible && !materDeliveryVisible && tabList.length"> {{ isSubMenuCollapse ? '展开' : '收起' }}
    </el-button>
  </div>
</template>

<script lang='ts'>
import TableSplitter from '@/components/common/TableSplitter.vue'
import { useTableSplitter } from '@/composables/useTableSplitter'
import { defineComponent, defineAsyncComponent, reactive, toRefs, onMounted, ref, watch } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { cloneDeep } from 'lodash'
import { getDetailById, deleteById, getPageList, putUrl } from '@/apis/Dictionary'
import { getPageList as getUrlList } from '@/apis/Form'
import { getUserDetailByUserId } from '@/apis/user'
import { setAchieve, customerConfirm, cancelBusiness, verifyBusinessAction } from '@/apis/Business'
import { getDropdownByType } from '@/apis/tool'

import { CostModel, ArrayRowsItem } from '@/model/Index'

import TableList from '@/components/common/TableList.vue'
import { MarketFeeFieldData } from '@/views/business/businessList/businessMarketFee/FieldFrom'

const FormComponent = defineAsyncComponent(() => import('@/components/Form/index.vue'))
const QuotationFormCom = defineAsyncComponent(() => import('@/views/business/quotation/From.vue'))
const OrderFormCom = defineAsyncComponent(() => import('@/views/order/From.vue'))
const ChargeFee = defineAsyncComponent(() => import('@/views/financial/chargeFee/Index.vue'))
const OutsourceFee = defineAsyncComponent(() => import('@/views/business/outsourceBusiness/outsourceFee/Index.vue'))
const FormDeliverComponent = defineAsyncComponent(() => import('@/views/repair/FormDeliver.vue'))
const ContactList = defineAsyncComponent(() => import('@/views/business/businessList/contact/Index.vue'))
const EngineerInfoList = defineAsyncComponent(() => import('@/views/business/businessList/engineerInfo/Index.vue'))
const MarketFee = defineAsyncComponent(() => import('@/views/business/businessList/businessMarketFee/Index.vue'))
const MarkerFeeCom = defineAsyncComponent(() => import('@/views/business/businessList/businessMarketFee/FormData.vue'))
const RegistCharge = defineAsyncComponent(() => import('@/views/financial/RegistCharge/Index.vue'))
const TraceInfo = defineAsyncComponent(() => import('@/components/traceInfo/Index.vue'))
const LogisticTable = defineAsyncComponent(() => import('@/views/logistics/components/Table.vue'))
const InvoiceNumber = defineAsyncComponent(() => import('@/views/business/businessList/InvoiceNumber/Index.vue'))
const DeliverTable = defineAsyncComponent(() => import('@/views/business/businessList/DeliverTable/Index.vue'))

import { TableName, permissionName } from '@/utils/enum'
import { FromFieldData } from '@/views/business/businessList/FieldFrom'
import { TableField } from '@/views/business/businessList/FieldTable'
import { FilterField } from './FilterField'
import { defaultDate, pageVo, pageSizes, numberTimes } from '@/utils/index'
import mixin from '@/mixins/index'
import CommandRender from '@/components/common/CommandRender.vue'
import ViewImageLlist from '@/components/common/ViewImageLlist.vue'

import { useI18n } from 'vue-i18n'
import $number from 'number-precision'
import $currency from 'currency.js'

/**
 *     Page Type:
 *     QUOTE,未报价的业务
 *     QUOTED,已报价的业务
 *     ORDER,待生成订单的业务 = 未报价的业务 + 已报价的业务
 *     CONFIRM,待客户确认的业务
 *     INVOICE,待开票的业务 = 已经生成订单的业务 & 订单含税
 *     RECEIVED,待收款的业务 = 已经生成订单的业务
 *     COMPLETED,已完成的业务 = 已收款的业务，如果是含税业务需要完成开票
 *     REMOVED,取消的业务
 */

export declare type PageType =
  'BUSINESS'
  | 'QUOTE'
  | 'QUOTED'
  | 'ORDER'
  | 'CONFIRM'
  | 'INVOICE'
  | 'RECEIVED'
  | 'COMPLETED'
  | 'REMOVED'
  | ''

export default defineComponent({
  name: 'Businesslistcom',
  components: {
    TableSplitter,
    FormComponent,
    TableList,
    ContactList,
    EngineerInfoList,
    TraceInfo,
    QuotationFormCom,
    MarketFee,
    ChargeFee,
    LogisticTable,
    OrderFormCom,
    CommandRender,
    InvoiceNumber,
    MarkerFeeCom,
    OutsourceFee,
    RegistCharge,
    ViewImageLlist,
    FormDeliverComponent,
    DeliverTable
  },
  props: {
    pageTypeIn: {
      type: String,
      required: false,
      default: ''
    },
    typeIn: {
      type: Number,
      required: false,
      default: 0
    },
    statusIn: {
      type: Number,
      required: false,
      default: 0
    },
    showStateFilter: {
      type: Boolean,
      required: false,
      default: false
    },
    defaultActiveTab: {
      type: Number,
      required: false,
      default: 1
    },
    tabPanelData: {
      type: Array,
      required: false,
      default: () => []
    },
    permission: {
      type: String,
      required: false,
      default: ''
    },
    canCommand: {
      type: Boolean,
      required: false,
      default: true
    },
    marketFeeCanCommand: {
      type: Boolean,
      required: false,
      default: true
    },
    showDefaultCommand: {
      type: Boolean,
      required: false,
      default: true
    },
    api: {
      type: String,
      required: false,
      default: 'business'
    },
    approvalParams: {
      type: Object,
      required: false,
      default: () => null
    },
    FilterFieldProps: {
      type: Array,
      required: false,
      default: () => FilterField
    },
    HiddenFieldFunProps: {
      type: Function,
      required: false
    },
    formDisabled: {
      type: Boolean,
      required: false,
      default: false
    },
    mainPage: {
      type: Boolean,
      required: false,
      default: false
    },
    businessTypeName: {
      type: String,
      required: false,
      default: 'TABLE_BUSINESS_LIST'
    },
    showSummary: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  setup(props) {
    const { t } = useI18n()
    const tableListRef = ref([])
    // const instance = getCurrentInstance()
    // const forceUpdate = (instance as any).ctx.$forceUpdate
    const defaultActiveTab = props.defaultActiveTab || 1
    // 业务登记新建设置默认值
    const tempFormField = FromFieldData.map((item: any) => {
      if (item.type === 1) {
        item.formList = item.formList.map((kk: any) => {
          if (kk.fieldKey === 'unitId') {
            kk.value = 4
          } else if (kk.fieldKey === 'type') {
            kk.value = 1
          } else if (kk.fieldKey === 'urgentId') {
            kk.value = 4
          } else if (kk.fieldKey === 'repairType') {
            kk.value = 2
          } else if (kk.fieldKey === 'businessClassId') {
            kk.value = 3
            kk.rules[0].required = true
            kk.config.isHide = false
          } else if (kk.fieldKey === 'engineerIds') {
            kk.rules[0].required = true
            kk.config.isHide = false
          }
          return kk
        })
      }
      return item
    })
    const dataMap = reactive({
      pageType: props.pageTypeIn,
      statusIn: props.statusIn,
      showStateFilter: props.showStateFilter,
      type: props.typeIn,
      TableName: TableName[props.businessTypeName],
      permissionName: props.permission || permissionName.BUSINESS_LIST,
      initFormData: cloneDeep(tempFormField),
      fromFieldData: cloneDeep(tempFormField),
      columnAllData: TableField
        .filter(item => props.HiddenFieldFunProps ? !props.HiddenFieldFunProps(item) : true)
        .filter(kk => !kk.visible || kk.visible({
          pageType: props.pageTypeIn,
          statusIn: props.statusIn,
          businessTypeName: props.businessTypeName
        })),
      mainPage: props.mainPage,
      initMarketFeeFieldData: cloneDeep(MarketFeeFieldData),
      marketFeeFieldData: cloneDeep(MarketFeeFieldData),
      marketFeeVisible: false,
      FilterField: props.FilterFieldProps,

      activeId: 0,
      list: [],
      total: 0,
      listLoading: false,
      viewImagesVisible: false,
      listQuery: {
        name: undefined,
        brand: undefined,
        model: undefined,
        serial: undefined,
        type: undefined,
        urgentId: undefined,
        customerCompanyName: undefined,
        customerCompanyContactName: undefined,
        customerCompanyContactPhone: undefined,
        salesManId: undefined,
        engineerId: undefined,
        outsourceCompanyName: undefined,
        outsourceCompanyContactName: undefined,
        outsourceCompanyContactPhone: undefined,
        startTime: '',
        endTime: '',
        receiveStartDate: undefined,
        receiveEndDate: undefined,
        status: undefined,
        receivedStatus: '',
        titleId: '',
        ...pageVo
      },
      pageSizes,
      dialogFormVisible: false,
      quotationVisible: false,
      orderVisible: false,
      tabList: props.tabPanelData,
      activeTab: defaultActiveTab,

      salesManId: '',
      newHpx: 0,
      statusOption: [],
      urgentOption: [],
      businessTypeOption: [],
      engineerOption: [],
      outsourceCompanyOption: [],
      outsourceCompanyContactOption: [],
      salesManOption: [],
      selectionArray: [],
      invoiceStatusOptions: [],
      titleCompanyOptions: [],
      commandState: 'edit',
      selectcCustomerCompanyId: 0,
      yejiVisible: false,
      achieveType: '',
      yejiOption: [],
      btnList: [],
      cancelBusinessVisible: false,
      cancelBusinessList: [],
      stepsList: [],
      submitStepsVisible: false,
      activeRow: {} as any,
      repairBackDialog: {
        engineerIds: [],
        outsourceCompanyId: '',
        outsourceCompanyContactId: '',
        type: ''
      },
      repairBackVisible: false,
      receivedRecordVisible: false,
      chargeVisible: false,
      selectRow: [],
      materDeliveryVisible: false,
      async handleCommand(command: string, val?: any) {
        dataMap.commandState = command
        switch (command) {
          case 'add':
            dataMap.handleCreate()
            break
          case 'copy':
          case 'edit':
          case 'view':
            dataMap.handleUpdate(val, command)
            break
          case 'delete':
            dataMap.handleDelete(val)
            break
          case 'refresh':
            dataMap.handleFilter()
            break
          case 'column':
            (tableListRef.value[0] as any).setColumnVisible = true
            break
          case 'current-change':
            dataMap.handleCurrentChange(val)
            break
          case 'size-change':
            dataMap.handleSizeChange(val)
            break
          case 'selection':
            dataMap.selectionArray = val
            break
          case 'quotation':
            if (!dataMap.selectionArray.length) {
              return ElMessage.error({
                message: '请选择业务',
                duration: 1000
              })
            }

            dataMap.selectcCustomerCompanyId = dataMap.selectionArray[0].customerCompanyId
            for (let i = 0; i < dataMap.selectionArray.length; i++) {
              const item = dataMap.selectionArray[i]
              if (dataMap.selectcCustomerCompanyId !== item.customerCompanyId) {
                return ElMessage.error({
                  message: '请选择同一个客户公司名称业务',
                  duration: 1000
                })
              }
              if (item.repairType === '预检' && ['自己维修', '现场维修'].includes(item.type)) {
                const {
                  fault,
                  changeParts,
                  checkDes
                } = item
                if (!fault || !changeParts || !checkDes) {
                  return ElMessage.error({
                    message: '预检且为自己维修或现场维修业务，故障现象、更换配件、检测情况字段不得为空！',
                    duration: 4000
                  })
                }
              }
            }

            dataMap.quotationVisible = true
            break
          case 'yeji':// 设置业绩类型
            dataMap.activeId = val.id
            dataMap.yejiOption = await getDropdownByType('AchieveType') || []
            // eslint-disable-next-line no-case-declarations
            const result = await getDetailById('business', dataMap.activeId)
            dataMap.achieveType = result.achieveType
            dataMap.yejiVisible = true
            break
          case 'order':
            if (!dataMap.selectionArray.length) {
              return ElMessage.error({
                message: '请选择业务',
                duration: 1000
              })
            }

            dataMap.selectcCustomerCompanyId = dataMap.selectionArray[0].customerCompanyId
            for (let i = 0; i < dataMap.selectionArray.length; i++) {
              const item = dataMap.selectionArray[i]
              if (dataMap.selectcCustomerCompanyId !== item.customerCompanyId) {
                return ElMessage.error({
                  message: '请选择同一个客户公司名称业务',
                  duration: 1000
                })
              }
            }
            dataMap.orderVisible = true
            break
          case 'repaired':
            dataMap.handleRepaired(val)
            break
          case 'marketFee':
            // if (['正式订单', '完成'].includes(val?.status)) {
            //   ElMessage.closeAll()
            //   return ElMessage.error(`该业务已${val?.status}，不能申请市场费！`)
            // }
            verifyBusinessAction(val.id, 'addMarketFee').then(() => {
              dataMap.activeRow = val
              dataMap.marketFeeFieldData = cloneDeep(dataMap.initMarketFeeFieldData)
              dataMap.marketFeeVisible = true
            })
            break
          case 'cancel':
            // ElMessageBox.confirm(`确定移除申请取消业务${val.name}吗`).then(async() => {
            //   const result = await cancelBusiness(val.id)
            // })
            verifyBusinessAction(val.id, 'cancel').then(() => {
              ElMessageBox.prompt(
                '取消业务理由：',
                '提交',
                {
                  confirmButtonText: t('table.confirm'),
                  cancelButtonText: t('table.cancel'),
                  cancelButtonClass: 'el-button--danger'
                }
              ).then((params: any) => {
                const { value } = params
                cancelBusiness(val.id, { comment: value }).then(result => {
                  if (result.success) {
                    dataMap.getList()
                    ElMessage({
                      message: '取消成功！',
                      type: 'success',
                      duration: 1000
                    })
                  } else {
                    dataMap.cancelBusinessVisible = true
                    dataMap.cancelBusinessList = result.steps
                  }
                })
              })
            })
            break
          case 'repairBack':
            dataMap.activeId = val.id
            getDetailById('business', val.id, { editInfo: true }).then((res: any) => {
              dataMap.repairBackVisible = true
              if (val.type === '外包维修') {
                dataMap.repairBackDialog = {
                  outsourceCompanyId: res.outsourceCompanyId,
                  outsourceCompanyContactId: res.outsourceCompanyContactId,
                  type: val.type,
                  engineerIds: []
                }
                dataMap.handleOutsourceCompanyFocus()
                dataMap.handleOutsourceCompanyConcatFocus()
              } else {
                dataMap.repairBackDialog = {
                  engineerIds: res.engineerIds || [],
                  type: val.type,
                  outsourceCompanyId: '',
                  outsourceCompanyContactId: ''
                }
                dataMap.handleEngineerFocus()
              }
            })
            break
          case 'received':// 查看收款记录
            dataMap.activeId = val.id
            dataMap.receivedRecordVisible = true
            break
          case 'businessBack':// 业务退回
            dataMap.activeId = val.id
            dataMap.chargeVisible = true
            dataMap.selectRow = [val]
            break
          case 'materDelivery':
            dataMap.activeId = val.id
            dataMap.materDeliveryVisible = true
            break
          case 'preview': {
            dataMap.activeRow = val
            dataMap.viewImagesVisible = true
          }
        }
      },
      handleRowClick(row: any) {
        dataMap.activeId = row.id
        dataMap.activeRow = row
      },
      calcHeight() {
        return 'calc(100% - 50px)'
      },
      getPageType() {
        return props.pageTypeIn
      },
      // 是否是登记业务页面
      isBusinessPage() {
        return this.getPageType() === 'BUSINESS'
      },
      // 是否是待收款页面
      isReceivedPage() {
        return this.getPageType() === 'RECEIVED'
      },
      // 是否是收款完成页面
      isReceivedDonePage() {
        return this.getPageType() === 'RECEIVED_DONE'
      },
      getList() {
        dataMap.listLoading = true
        const parmas = { ...dataMap.listQuery }
        if (props.pageTypeIn) {
          Object.assign(parmas, { pageType: props.pageTypeIn })
        }
        if (props.typeIn) {
          Object.assign(parmas, { type: props.typeIn })
        }
        if (props.statusIn) {
          Object.assign(parmas, { status: props.statusIn })
        }
        if (props.approvalParams) {
          Object.assign(parmas, props.approvalParams)
        }
        getPageList(props.api, parmas).then((res: any) => {
          dataMap.list = res.data?.map((item: any) => {
            return {
              ...item,
              orderFee4: dataMap.numberTimes(item.orderFee, item.amount, true)
            }
          }) || []
          dataMap.total = res.total
          dataMap.listLoading = false
          dataMap.activeId = dataMap.list.length ? dataMap.list[0].id : 0
          dataMap.activeRow = dataMap.list.length ? dataMap.list[0] : null
        }).catch(() => {
          dataMap.listLoading = false
        })
      },
      numberTimes: (price: any, amount: any, isCurrency: boolean) => numberTimes(price, amount, isCurrency),
      handleReset() {
        dataMap.listQuery = {
          name: undefined,
          brand: undefined,
          model: undefined,
          serial: undefined,
          type: undefined,
          urgentId: undefined,
          customerCompanyName: undefined,
          customerCompanyContactName: undefined,
          customerCompanyContactPhone: undefined,
          salesManId: undefined,
          engineerId: undefined,
          outsourceCompanyName: undefined,
          outsourceCompanyContactName: undefined,
          outsourceCompanyContactPhone: undefined,
          startTime: defaultDate[0],
          endTime: defaultDate[1],
          receiveStartDate: undefined,
          receiveEndDate: undefined,
          status: undefined,
          receivedStatus: '',
          titleId: '',
          ...pageVo
        }
        dataMap.handleFilter()
      },
      handleFilter() {
        const {
          startTime,
          endTime
        } = dataMap.listQuery
        const tempsStart = startTime ? new Date(startTime).getTime() : 0
        const tempdEnd = endTime ? new Date(endTime).getTime() : 0
        if (!tempsStart) {
          return ElMessage.error({
            message: '请选择开始时间',
            duration: 1000
          })
        } else if (!tempdEnd) {
          return ElMessage.error({
            message: '请选择结束时间',
            duration: 1000
          })
        } else if (tempsStart > tempdEnd) {
          return ElMessage.error({
            message: '开始时间必须小于结束时间',
            duration: 1000
          })
        }

        const { receiveStartDate, receiveEndDate } = dataMap.listQuery
        if (receiveStartDate && receiveEndDate && new Date(receiveStartDate).getTime() > new Date(receiveEndDate).getTime()) {
          return ElMessage.error({
            message: '收款开始日期不能晚于结束日期',
            duration: 1000
          })
        }

        dataMap.getList()
      },

      handleCreate() {
        dataMap.activeId = 0
        dataMap.fromFieldData = cloneDeep(dataMap.initFormData)
        dataMap.fromFieldData.map((formList: any) => {
          return formList.formList.map((field: any) => {
            if (field.fieldKey === 'no') {
              field.config.isHide = true
            }
            return field
          })
        })
        dataMap.dialogFormVisible = true
      },
      handleUpdate(row: any, command: string) {
        dataMap.activeId = row.id
        dataMap.fromFieldData = cloneDeep(dataMap.initFormData)
        if (command === 'copy') {
          this.handleUpdateFun(row)
          dataMap.fromFieldData.map((formList: any) => {
            return formList.formList.map((field: any) => {
              if (field.fieldKey === 'no') {
                field.config.isHide = true
              }
              return field
            })
          })
        } else if (command === 'view') {
          this.handleUpdateFun(row)
        } else {
          getUrlList(`business/${row.id}/actions/editable`).then(() => {
            this.handleUpdateFun(row)
          })
        }
      },
      handleUpdateFun(row: any) {
        getDetailById('business', row.id, { editInfo: true }).then((res: any) => {
          dataMap.fromFieldData.forEach((k: any) => {
            k.formList.forEach(async(field: any) => {
              field.value = res[field.fieldKey] || field.value
              switch (field.fieldKey) {
                case 'customerContactIds': {
                  const result = await getUrlList(field.config.url, { companyId: res.customerCompanyId })
                  field.option = result
                }
                  break
                case 'customerCompanyId': {
                  const result = await getUrlList('customerCompany/dropdown', {
                    ids: res.customerCompanyId
                  })
                  field.option = result.map((item: any) => {
                    return {
                      ...item
                    }
                  })
                }
                  break
                case 'salesManId': {
                  const result = await getUserDetailByUserId(res.salesManId)
                  field.option = [{
                    id: result.id,
                    name: result.name
                  }]
                }
                  break
              }
            })
          })
          dataMap.dialogFormVisible = true
        })
      },
      handleDelete(row: any) {
        ElMessageBox.confirm(
          '确定要删除选中数据吗？',
          '删除',
          {
            confirmButtonText: t('table.confirm'),
            cancelButtonText: t('table.cancel'),
            type: 'warning',
            cancelButtonClass: 'el-button--danger'
          }
        )
          .then(() => {
            deleteById('business', row.id).then(() => {
              dataMap.getList()
              ElMessage({
                message: '删除成功',
                type: 'success',
                duration: 1000
              })
            })
          })
      },
      handleSubmit(result: any) {
        if (result && !result.success) {
          dataMap.submitStepsVisible = true
          dataMap.stepsList = result.steps
          return
        }
        dataMap.getList()
      },
      handleSetYeji() {
        setAchieve(dataMap.activeId, { achieveType: dataMap.achieveType }).then(() => {
          dataMap.getList()
          dataMap.achieveType = ''
          dataMap.yejiVisible = false
        }).catch(() => {
          dataMap.yejiVisible = false
        })
      },
      handleQuotatioSubmit() {
        dataMap.getList()
      },
      handleRepaired(row: any) {
        ElMessageBox.confirm(
          '确定选中业务已经完成？',
          '确定',
          {
            confirmButtonText: t('table.confirm'),
            cancelButtonText: t('table.cancel'),
            type: 'warning',
            cancelButtonClass: 'el-button--danger'
          }
        )
          .then(() => {
            customerConfirm(row.id).then(() => {
              dataMap.getList()
              ElMessage({
                message: '操作成功',
                type: 'success',
                duration: 1000
              })
            })
          })
      },
      handleCurrentChange(page?: any) {
        dataMap.listQuery.page = page
        dataMap.getList()
      },
      handleSizeChange(size: any) {
        dataMap.listQuery.size = size
        dataMap.handleCurrentChange(1)
      },
      getDropdownList() {
        getUrlList('dropdown/BusinessStatus').then((res: any) => {
          dataMap.statusOption = res || []
        })
        getUrlList('urgency/dropdown').then((res: any) => {
          dataMap.urgentOption = res || []
        })
        getUrlList('dropdown/BusinessType').then((res: any) => {
          dataMap.businessTypeOption = res || []
        })
        getUrlList('dropdown/BusinessInvoicingStatus').then((res: any) => {
          dataMap.invoiceStatusOptions = res || []
        })
      },
      handleEngineerFocus() {
        getUrlList('user/dropdown/engineers?all=true').then((res: any) => {
          dataMap.engineerOption = res || []
        })
      },
      handleOutsourceCompanyFocus() {
        getUrlList('outsourceCompany/dropdown').then((res: any) => {
          dataMap.outsourceCompanyOption = res || []
        })
      },
      handleOutsourceCompanyConcatFocus() {
        getUrlList('outsourceCompanyContact/page', { outsourceCompanyId: dataMap.repairBackDialog.outsourceCompanyId }).then((res: any) => {
          dataMap.outsourceCompanyContactOption = res.data || []
        })
      },
      handleOutsourceCompanyChange() {
        dataMap.repairBackDialog.outsourceCompanyContactId = ''
        dataMap.handleOutsourceCompanyConcatFocus()
      },
      handleSalesManFocus() {
        getUrlList('user/dropdown/salesman').then((res: any) => {
          dataMap.salesManOption = res || []
        })
      },
      handleTabClick(item: any) {
        dataMap.activeTab = item.id
      },
      multiWithCurrency(num1: number | string, num2: number | string, isCurrency: boolean): $currency | number {
        if (isCurrency) {
          return $currency($number.times(num1, num2))
        }
        return $number.times(num1, num2)
      },
      handleFilterFocus(field: any) {
        if (field.focus) {
          dataMap[field.focus]()
        }
      },
      handleFilterTitleFocus() {
        getUrlList('ticketTitle/dropdown').then((res: any) => {
          dataMap.titleCompanyOptions = res || []
        })
      },
      getTitleCompanyOptions() {
        return dataMap.titleCompanyOptions ?? []
      },
      handleFilterOptions(field: any) {
        if (field.options) {
          return dataMap[field.options]
        }
        return []
      },
      tableRowClassName({ row }: any) {
        if (props.mainPage) {
          const obj = {
            待报价: 'row-red',
            待订单: 'row-blue',
            已取消: 'row-gray'
          }
          return obj[row.status] || ''
        }
        return ''
      },
      async handleRepairBackSubmit() {
        try {
          const {
            outsourceCompanyId,
            outsourceCompanyContactId,
            engineerIds,
            type
          } = dataMap.repairBackDialog
          const temp = type === '外包维修'
            ? {
              outsourceCompanyId,
              outsourceCompanyContactId
            }
            : { engineerIds }
          await putUrl(`business/${dataMap.activeId}/actions/change/engineer`, {
            rework: true,
            ...temp
          })
          ElMessage({
            message: '操作成功！',
            type: 'success',
            duration: 1000
          })
          dataMap.getList()
        } catch (error) {
          console.log(error, 'error')
        }
      }
    })

    const { mixinData } = mixin(dataMap)

    const splitter = useTableSplitter({
      storageKey: 'erp.split_ratio./business/businessList',
      defaultRatio: 0.38,
      minTopHeight: 140,
      minBottomHeight: 0,
      splitterHeight: 22,
      paginationHeight: 52,
      onResize: (topH) => {
        dataMap.newHpx = topH
      }
    })

    watch(() => mixinData.isFilterCollapse, () => {
      setTimeout(() => {
        splitter.applyLayout()
      }, 50)
    })
    onMounted(async() => {
      mixinData.initHeight()
      dataMap.btnList = [
        {
          pkey: `${dataMap.permissionName}_EDIT`,
          name: '编辑',
          command: 'edit'
        },
        {
          pkey: `${dataMap.permissionName}_EDIT`,
          name: '查看',
          command: 'view'
        }, {
          pkey: `${dataMap.permissionName}_CANCEL`,
          name: '申请取消',
          command: 'cancel',
          type: 'danger'
        },
        // {
        //   pkey: `${dataMap.permissionName}_REPAIRED`,
        //   name: '客户确认',
        //   command: 'repaired'
        // },
        {
          pkey: `${dataMap.permissionName}_COPY`,
          name: '复制',
          command: 'copy'
        }, {
          pkey: `${dataMap.permissionName}_YJ`,
          name: '设置业绩类型',
          command: 'yeji'
        }, {
          pkey: 'BUSINESS_LIST_ADD_MARKET_FEE',
          name: '申请市场费',
          command: 'marketFee'
        }, {
          pkey: 'BUSINESS_LIST_REPAIR_BACK',
          name: '返修',
          command: 'repairBack',
          visible: (row: any) => {
            return row.status !== '已完成' && ['自己维修', '功能改造', '现场维修', '外包维修'].includes(row.type)
          }
        },
        {
          pkey: `${dataMap.permissionName}_RECEIVED_CECORD`,
          name: '明细',
          command: 'received'
        },
        {
          pkey: `${dataMap.permissionName}_RECEIVED_BACK`,
          name: '退款',
          command: 'businessBack',
          visible: (row: any) => row.receivedStatus !== '未收款'
        },
        {
          pkey: `${dataMap.permissionName}_LIST`,
          name: '查看大图',
          command: 'preview'
        }, {
          pkey: 'BUSINESS_LIST_REPAIR_BACK',
          name: '材料出库',
          command: 'materDelivery',
          visible: (row: any) => {
            return row.status !== '已完成' && ['非维修类', '外包维修'].includes(row.type)
          }
        }
      ]

      dataMap.listQuery.startTime = defaultDate[0]
      dataMap.listQuery.endTime = defaultDate[1]
      dataMap.getList()
      dataMap.getDropdownList()
    })
    return {
      t,
      ...toRefs(dataMap),
      ...toRefs(mixinData),
      ...splitter,
      handleSubMenuCollapse: splitter.toggleSubMenuCollapse,
      tableListRef
    }
  }
})
</script>
<style lang="scss" scope>
.statusStyle {
  .status {
    padding: 0 4px;
    border-radius: 6px;
    margin-right: 7px;
    font-size: 10px;
    color: #fff;
  }
}

.redStatusStyle {
  .icon-tubiao-40 {
    color: #E74228;
  }

  .status {
    background-color: #E74228;
  }
}

.yellowStatusStyle {
  .icon-tubiao-40 {
    color: #ffa217;
  }

  .status {
    background-color: #ffa217;
  }
}

.warming-fp {
  border-radius: 4px;
  border: 1px solid $red;
  color: $red;
  padding: 8px;
  margin-bottom: 20px;
}
</style>
